import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import AddJobpostingDetailsNotes from "./AddJobpostingDetailsNotes";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../../../../_utilities/getUserInfo";
import { GetTimeZone } from "../../../../_utilities/GetTimeZone";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import { DashboardPlusicon } from "../../../../Icons/DashboardPlusicon";

import "./JobpostingDetailsNotes.css";
import EditIcon from "@mui/icons-material/Edit";
import { Notescall } from "../../../../Icons/Notescall";
import { Notesemail } from "../../../../Icons/Notesemail";

const JobpostingDetailsNotes = ({ data, selectedJobId, onReceiveProps }) => {
  const [user, setUser] = useState([]);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [isLoadDoc, setIsLoadDoc] = useState(false);
  const [noteState, setNoteState] = useState("");
  const [selectedNote, setSelectedNote] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [isValidUser, setIsValidUser] = useState(false);

  const dispatch = useDispatch();

  const notesCode = useSelector((state) => state.ListNotes.code);

  useEffect(() => {
    if (notesCode === 404) {
      setIsValidUser(true);
    }
  }, [notesCode]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      const userInfo = await getUserDetails();
      setUserDetails(userInfo);
    };
    fetchUserDetails();
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      setUser(data);
      setIsLoadDoc(false);
    }
  }, [data]);

  const onReceivePropsHandler = (pannel, load) => {
    setIsRightSidePannel(pannel);
    setIsLoadDoc(load);
    if (load === true) {
      setTimeout(() => {
        onReceiveProps("notes");
      }, 1200);
    }
    var element = document.getElementsByTagName("body");
    element[0].style.overflow = "";
  };

  const notesHandler = (type, data) => {
    setIsRightSidePannel(true);
    setNoteState(type);
    setSelectedNote(type === "Create" ? null : data);
    var element = document.getElementsByTagName("body");
    element[0].style.overflow = "hidden";
  };

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <>
      <div
        style={{ display: "flex", padding: "0 0 20px 0", fontWeight: "600" }}
      >
        Notes
        <div>
          {!isValidUser && (
            <div
              className="addnotessection"
              style={{ display: "flex", gap: "10px", right: "0px" }}
              onClick={() => {
                notesHandler("Create", null);
              }}
            >
              <DashboardPlusicon width={35} height={36} />
              <h4 className="addnotetext">Add Notes </h4>
            </div>
          )}
        </div>
      </div>
      <div>
        {user.length > 0 ? (
          <>
            {user.map((elem, i) => {
              return (
                <>
                  <div
                    className="notesBox"
                    style={{
                      backgroundColor:
                        elem.noteType === "Call" ? "#FBF6FF" : "#F5F9FF",
                      borderColor:
                        elem.noteType === "Call" ? "#E1BEE7" : "#BBDEFB",
                    }}
                    key={i}
                  >
                    <div className="usericon">
                      {elem.noteType === "Call" ? (
                        <Notescall
                          primaryColor={storedTheme?.secondaryColor}
                          primaryFontColor={storedTheme?.secondaryFontColor}
                          width={32}
                          height={32}
                        />
                      ) : (
                        <Notesemail
                          primaryColor={storedTheme?.secondaryColor}
                          primaryFontColor={storedTheme?.secondaryFontColor}
                          width={32}
                          height={32}
                        />
                      )}
                    </div>
                    <div className="jobnote">
                      <b>
                        {elem.noteType === "Call" ? "Call " : "E-mail "}(
                        <span style={{ fontWeight: "500" }}>
                          By {elem.firstName + " " + elem.lastName}
                        </span>
                        )
                      </b>
                      <div>
                        <span className="createdDate">
                          {GetTimeZone(elem.createdAt)}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        marginLeft: "19px",
                        maxWidth: "calc(100% - 58px)",
                        border: "1 px solid #ffffff",
                        borderRadius: "10px",
                        overflow: "hidden",
                        background: "#f9f9f9 0% 0% no-repeat padding-box",
                        marginBottom: "20px",
                        minHeight: "70px",
                        padding: "0px 10px",
                      }}
                      dangerouslySetInnerHTML={{ __html: elem.notes }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "30px",
                        right: "20px",
                      }}
                    >
                      {elem.userId === userDetails.userId ? (
                        <IconButton
                          color="primary"
                          onClick={() => {
                            notesHandler("Update", elem);
                          }}
                          component="label"
                          style={{
                            width: "30px",
                            height: "30px",
                            padding: "0",
                          }}
                        >
                          {/* <EditingIcon /> */}
                          <EditIcon
                            className="appediticon1"
                            sx={{ color: storedTheme?.secondaryColor }}
                          />
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              );
            })}
          </>
        ) : (
           <div className="detail-card-empty">
             <img
               src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
               alt="No data"
             />
             No notes found
           </div>
        )}
      </div>

      <div className="contentSection">
        {isRightSidePannel ? (
          <AddJobpostingDetailsNotes
            onReceivePropsHandler={onReceivePropsHandler}
            noteState={noteState}
            selectedNote={selectedNote}
            jobId={selectedJobId}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default JobpostingDetailsNotes;
